import { AnyAction, configureStore, createListenerMiddleware, isRejected } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';
import { enqueueSnackbar } from 'notistack';

import { resettableRootReducer } from './RootReducer';

const listenerMiddleware = createListenerMiddleware();
listenerMiddleware.startListening({
  effect: (action: AnyAction) => {
    const { payload } = action;
    const data = payload && typeof payload === 'object' && 'data' in payload ? payload.data : undefined;
    const statusText =
      payload && typeof payload === 'object' && 'statusText' in payload ? payload.statusText : undefined;

    const message =
      (typeof statusText === 'string' && statusText) ||
      (data && typeof data === 'object' && 'detail' in data && typeof data.detail === 'string' ? data.detail : null);

    if (message && typeof enqueueSnackbar === 'function') {
      enqueueSnackbar(message);
    }
  },
  matcher: isRejected,
});

export const store = configureStore({
  devTools: import.meta.env.DEV,
  reducer: resettableRootReducer,
  // eslint-disable-next-line perfectionist/sort-objects
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().prepend(listenerMiddleware.middleware),
  // eslint-disable-next-line perfectionist/sort-objects
  enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat(Sentry.createReduxEnhancer({})),
});
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppStore = typeof store;
